__turbopack_context__.v({
  "checkbox": "SizePanel-module-scss-module__ypl38q__checkbox",
  "panelClicked": "SizePanel-module-scss-module__ypl38q__panelClicked",
  "sizePanel": "SizePanel-module-scss-module__ypl38q__sizePanel",
});
